// @flow

import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.freeDammTostada',
  title: 'hardCoded.title.freeDammTostada',
  slug: titleToSlug('hardCoded.title.freeDammTostada'),
  catalog: {
    title: 'hardCoded.catalog.title.freeDammTostada',
    catalogMedia,
    price: numberToCurrency('3.60'),
    color: '#ab613d'
  }
}
